<template>
  <b-container
    fluid
    :class="[
      { scrolled: scrollPosition > 50 }]"
  >
    <b-navbar toggleable="lg" type="light" class="container px-0">
      <b-navbar-brand to="/">Growth <span>Labs</span></b-navbar-brand>

      <b-navbar-toggle target="nav-collapse"> </b-navbar-toggle>

      <b-collapse id="nav-collapse" is-nav>
        <b-navbar-nav class="ml-auto">
          <b-nav-item :to="{ name: 'Home' }">Home</b-nav-item>
          <b-nav-item :to="{ name: 'Services' }">Services</b-nav-item>
          <b-nav-item :to="{ name: 'About' }">About</b-nav-item>
          <b-nav-item :to="{ name: 'Contact' }">Contact</b-nav-item>
        </b-navbar-nav>
      </b-collapse>
    </b-navbar>
  </b-container>
</template>

<script>
export default {
  name: "Navbar",
  data() {
    return {
      scrollPosition: null
    };
  },
  computed: {
    activeRoute() {
      return this.$route.name;
    }
  },
  methods: {
    updateScroll() {
      this.scrollPosition = window.scrollY;
    }
  },
  mounted() {
    window.addEventListener("scroll", this.updateScroll);
  }
};
</script>

<style lang="scss">
  .navbar-light {
    font-weight: 500;
    .navbar-brand {
      span {
        color: $light-blue;
      }
    }
    .navbar-nav {
      .nav-item {
        a.nav-link {
          color: $dark-blue;

          &:focus {
            color: $light-blue;
          }
        }
        a.nav-link .router-link-exact-active .router-link-active {
          color: $light-blue;
        }
      }
    }
  }

  .inverted {
    .navbar-light {
      .navbar-brand {
        color: $white;
      }

      .navbar-nav {
        .nav-item {
          .nav-link {
            color: $white;

            &:focus {
              color: $light-blue;
            }
          }
        }
      }
    }
  }

  .scrolled {
    background-color: rgb(45, 49, 66, 0.9);

    .navbar-light {
      padding: 5px 0;
      border-bottom: none;
      .navbar-brand {
        color: $white;
      }
      .navbar-nav {
        .nav-item {
          .nav-link {
            color: $white;
            &:hover {
              color: $light-blue;
            }
            &:focus {
              color: $light-blue;
            }
          }
        }
      }
    }
  }
</style>
